import { Field, Label } from "@headlessui/react";
import cn from "classnames";
import { ExclamationMark } from "@/icons";
import { FC } from "react";
type ExpectedFieldProps = {
  value?: unknown;
  placeholder?: unknown;
  disabled?: boolean;
  required?: boolean;
  name?: unknown;
};

export type RoundFormFieldProps<T> = {
  label?: string;
  invalidText?: string;
  formControl: FC<Omit<T, "label" | "invalidText" | "formControl">>;
} & T;
export const RoundFormField = function <T extends ExpectedFieldProps>({
  label,
  invalidText,
  formControl: FormControl,
  ...props
}: RoundFormFieldProps<T>) {
  return (
    <Field
      className="group relative flex w-full flex-col"
      disabled={props.disabled}
    >
      {label && (
        <Label
          className={cn(
            "text-body-2xs text-swdc-gray-300 cursor-text pb-2 leading-none font-medium",
            props.required && "after:text-swdc-red-500 after:content-['*'/'']",
          )}
        >
          {label}
        </Label>
      )}
      <div
        className={cn(
          "bg-swdc-white text-body-s text-swdc-black-600 placeholder:text-swdc-gray-400 mb-0.5 flex h-10 h-full w-full flex-row items-center gap-x-1 rounded-[40px] border px-4 py-2 transition-colors duration-300 ease-linear outline-none",
          "invalid" in props && props.invalid
            ? "border-swdc-red-500"
            : "border-swdc-gray-200 group-focus-within:border-swdc-black-600 group-focus:border-swdc-black-600 group-active:border-swdc-black-600",
        )}
      >
        <FormControl aria-errormessage={`invalid-${props.name}`} {...props} />
      </div>
      {"invalid" in props && Boolean(props.invalid) && (
        <div className="flex items-center gap-x-2 pt-px">
          <ExclamationMark className="flex-none" aria-hidden />
          <span
            className="text-body-2xs text-swdc-red-500 text-left leading-none font-medium"
            id={`invalid-${props.name}`}
          >
            {invalidText}
          </span>
        </div>
      )}
    </Field>
  );
};
